import { render, staticRenderFns } from "./baseTable4.vue?vue&type=template&id=e852d4ba"
import script from "./baseTable4.vue?vue&type=script&lang=js"
export * from "./baseTable4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports